import { ConfigService } from './app/services/config/config.service';
import { RawConfig } from './app/services/config/raw-config.model';

export class ConfigLoader {
    // TODO: Update this to use the Fetch API https://developers.google.com/web/updates/2015/03/introduction-to-fetch
    loadConfigDotJson(callback: () => void): void {
        const configDotJson = 'config.json';

        // See: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/Synchronous_and_Asynchronous_Requests
        const xhr = new XMLHttpRequest();
        xhr.open('GET', configDotJson, true);

        // noinspection SpellCheckingInspection
        xhr.onload = () => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    try {
                        const json = JSON.parse(xhr.responseText);
                        if (json) {
                            const rawConfig = json as RawConfig;
                            ConfigService.SET_CONFIG(rawConfig);
                            callback();
                        } else {
                            console.error(xhr.responseText);
                        }
                    } catch (error) {
                        if (error.name === 'SyntaxError') {
                            console.error(error.message);
                        } else {
                            throw error;
                        }
                    }
                } else {
                    console.error(xhr.statusText);
                }
            } else {
                console.error(configDotJson + ' not loaded correctly!');
            }
        };

        // noinspection SpellCheckingInspection
        xhr.onerror = () => {
            console.error(xhr.statusText);
        };

        xhr.send(null);
    }
}
